import type { IEmailMarketingTemplateListItem } from "api/rpc/2024-04/facilityAdmin/marketing/emailMarketingTemplatesTypes";
import { ingestEmailDocumentFromApi } from "../domain/ingest-api-document";
import {
  emailDocumentValidationFailure,
  emailDocumentValidationSuccess,
  type TEmailDocumentValidationResult,
} from "../schema/emailDocumentValidationResult";

export function normalizeEmailBuilderTemplateActiveDocument(
  activeDocument: unknown,
): TEmailDocumentValidationResult {
  const validation = ingestEmailDocumentFromApi(activeDocument);

  if (validation.ok === false) {
    return emailDocumentValidationFailure(validation.errors);
  }

  return emailDocumentValidationSuccess(validation.document);
}

export function filterEmailBuilderTemplatesPanelList(
  templates: IEmailMarketingTemplateListItem[],
  excludeTemplateId: number | null,
): IEmailMarketingTemplateListItem[] {
  if (excludeTemplateId == null) {
    return templates;
  }

  return templates.filter(template => template.id !== excludeTemplateId);
}

export function emailBuilderTemplatesHasMore(pageLength: number, pageLimit: number): boolean {
  return pageLength === pageLimit;
}
